var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"id":"drawer"}},[_c('AddTutorial',{staticClass:"col",staticStyle:{"margin-right":"-80px"}}),_c('TutorialsList',{staticClass:"col"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }